<template>
  <div v-if="data" id="main" class="reportContainer">
    <div class="coverContainer">
      <img :src="topImg" alt="">
      <div class="coverInfo">
        {{ pageInfo.studentGrade + pageInfo.studentClass }}
        {{ pageInfo.school }}
      </div>
    </div>
    <IntroBase />
    <div class="bigTitle partTest" />
    <SamllTitle title="参测人员概况" />
    <div class="formatIntro">
      本次心理健康测评<span>{{
        pageInfo.studentGrade + pageInfo.studentClass
      }}</span>应参测人数<span>{{ data.yinCeRenShu }}</span>人，实际参测人数<span>{{ data.shiCeRenShu }}</span>人，有效问卷人数<span>{{ data.youXiaoWenJuan }}</span>人，有效率<span>{{ data.youXiaoLu * 100 + "%" }}</span>。
    </div>
    <TableList
      class="wsTableList"
      table-title="参测人员概况"
      cell-color="#FAB839"
      tip="*说明:有效问卷是指学生回答测评符合测评要求"
      :headers="SurveyPersonnelHeadersList"
      :table-data="SurveyPersonnelBodyList"
    />
    <SamllTitle title="男／女生参测人员分布情况" style="margin-top: 81px" />
    <div class="pieChart">
      <div id="piePercentageChart" class="pie" />
    </div>
    <div class="formatIntro">
      本次心理健康测评<span>{{
        pageInfo.studentGrade + pageInfo.studentClass
      }}</span>实际参测人数<span>{{ data.shiCeRenShu }}</span>人，女生<span>{{ data.shiCeRenShuFemale }}</span>人，占比<span>{{
        ((data.shiCeRenShuFemale / data.yinCeRenShu) * 100).toFixed(2)
      }}%</span>；男生<span>{{ data.shiCeRenShuMan }}</span>人，占比<span>{{
        ((data.shiCeRenShuMan / data.yinCeRenShu) * 100).toFixed(2)
      }}%</span>；
    </div>
    <div class="bigTitle resultT" />
    <SamllTitle title="学生心理健康总体情况" style="margin-top: 100px" />
    <div class="listContainer">
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">学生心理健康状态汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="healthSummaryChart" class="pie" />
          </div>
          <div class="formatIntro">
            参照《儿少心理健康量表》5种健康状态常模，在本次心理健康测评中，
            <div
              v-for="(item, index) in getHealthSummaryPieChartData"
              :key="index"
            >
              处于{{ item.name }}的学生有<span>{{ item.value }}</span>人，占比<span>{{
                ((item.value / needChange.shiCeRenShu) * 100).toFixed(2) + "%"
              }}</span>；
            </div>
            <!-- 处于高健康状态的学生有<span>36</span>人，占比<span>84%</span>；处于较好健康状态的学生有<span>1</span>人，占比<span>3%</span>；处于一般健康状态的学生有<span>5</span>人；占比<span>5%</span>；处于亚健康状态的学生有<span>2</span>人，占比<span>5%</span>；处于预警状态的学生有<span>1</span>人；占比<span>3%</span>; -->
          </div>
          <TableList
            :headers="healthSummaryTableHeadersList"
            :table-data="healthSummaryTableBodyList"
            is-show-top-tip
            table-title="参照资料"
          />
        </div>
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">男／女生心理健康状态汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="barPercentageChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照《儿少心理健康量表》5种健康状态常模，在本次心理健康测评中，男/女生的具体情况如下：
          </div>
          <div
            v-for="(item, index) in barPercentageChartData.name"
            :key="index"
            class="formatIntro"
            style="margin-top: 0"
          >
            处于{{ item }}的男生有<span>{{
              barPercentageChartData.man[index]
            }}</span>人，女生有<span>{{ barPercentageChartData.male[index] }}</span>人；
          </div>
        </div>
      </div>
    </div>
    <SamllTitle title="学生心理健康预警情况" style="margin-top: 88px" />
    <div class="listContainer">
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">分级预警人数汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="EarlyPieChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照分级预警的操作定义，在本次心理健康测评中
            <div
              v-for="(yujing, yui) in EarlyPieChartData.chartData"
              :key="yui"
            >
              {{ yujing.name }}有<span>{{ yujing.value }}</span>人,占比<span>{{
                ((yujing.value / needChange.yinCeRenShu) * 100).toFixed(2)
              }}%</span>；
            </div>
          </div>
          <div class="formatIntro" style="margin-top: 0">
            *分级预警的操作定义：
          </div>
          <div class="formatIntro" style="margin-top: 0">
            第一类预警：5个维度中的任一维度处于预警状态。
          </div>
          <div class="formatIntro" style="margin-top: 0">
            第二类预警：至少有3个维度为预警状态的学生，且其中1个为情绪维度。
          </div>
          <div class="formatIntro" style="margin-top: 0">
            第三类预警：第24题选择选项G（我有意摧残自己的健康，有自残或自杀行为。）
          </div>
        </div>
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">男／女生分级预警人数汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="EarlyBarChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照分级预警的操作定义，在本次心理健康测评中，男生、女生出现预警的具体情况如下：
          </div>
          <div
            v-for="(early, index) in EarlyPieChartData.chartData"
            :key="index"
            class="formatIntro"
            style="margin-top: 0"
          >
            处于{{ early.name }}的男生有<span>{{
              EarlyPieChartData.man[index]
            }}</span>人，女生有<span>{{ EarlyPieChartData.male[index] }}</span>人；
          </div>
        </div>
      </div>
    </div>
    <SamllTitle title="各维度心理健康状态分析" style="margin-top: 88px" />
    <div class="listContainer">
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">各维度心理健康状态分布表</div>
        </div>
        <div
          v-for="(value, key, i) in data.scaleItems"
          :key="i"
          class="listValue"
          style="padding-top: 45px"
        >
          <TableList
            :key="i"
            :table-title="
              '<span>' +
                pageInfo.studentGrade +
                pageInfo.studentClass +
                '</span>' +
                '学生在' +
                '<span>' +
                key +
                '</span>' +
                '的心理健康状态分布表'
            "
            show-summary
            :headers="filterHeaders(value)"
            :table-data="filterTableBody(value)"
          />
        </div>
        <TableList
          class="wsTableList1"
          is-show-top-tip
          :headers="weiduTableHeadersList"
          :table-data="weiduTableDataList"
          table-title="参照资料"
        />
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">各维度预警状态概述</div>
        </div>
        <div class="listValue" style="padding-top: 45px">
          <div class="pieChart">
            <div id="barDimentionChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            本次心理健康测评中，{{
              pageInfo.studentClass
            }}学生在各维度处于预警状态的具体情况如下：
          </div>
          <div
            v-for="(dimention, index) in dimentionEarlyPieChartData.name"
            :key="index"
            class="formatIntro"
            style="margin-top: 0"
          >
            {{ dimention }}中有<span>{{
              dimentionEarlyPieChartData.value[index]
            }}</span>人处于预警状态；
          </div>
          <div class="formatIntro" style="margin-top: 0">
            综合上述数据个性维度、认知维度的预警状态人数相对较多，需要引起关注。
          </div>
        </div>
      </div>
    </div>
    <div class="bigTitle summaryT" />
    <div class="intro">
      <div class="introItem">
        学生总体心理健康情况如上，但有个别学生的心理状态需要特别关注，建议学校提供相应的专业评估与心理支持。本测评结果不能作为医学诊断。
      </div>
    </div>
    <div
      v-if="
        schoolType == '0' ||
          schoolType == '1' ||
          schoolType == '2' ||
          schoolType == '99'
      "
      class="bigTitle scienceT"
    />
    <Science :school-type="schoolType" />
    <div class="bigTitle noticeT" />
    <div class="intro">
      <div class="introItem">
        本测评报告不可作为精神疾病、心理障碍诊断的依据，仅供参考。
      </div>
    </div>
  </div>
</template>
<script>
import SamllTitle from '../../components/smallTitle.vue'
import TableList from '../../components/tableList.vue'
import Science from '../../components/science.vue'
import IntroBase from '../../components/introBase.vue'
// import request from "../../utils/request"
// import getReportPdf from "../../utils/getReportPdf";
import htmlToPdf from '../../utils/htmlToPdf'
// import Html2Canvas from "html2canvas";
// import { jsPDF } from "jspdf";
import { mixins } from '../../utils/mixins'
import {
  getChildrenTeamReportDetailData,
  getChildrenTeamReportItemdetail2Data
} from '../../api/report'
const tableKey = {
  高健康状态: 'high',
  较好健康状态: 'preferably',
  一般健康状态: 'commonly',
  亚健康状态: 'subhealthy',
  预警状态: 'early'
}
export default {
  components: {
    SamllTitle,
    TableList,
    Science,
    IntroBase
  },
  mixins: [mixins],
  data() {
    return {
      data: undefined,
      pageInfo: undefined,
      topImg: require('../../assets/images/classReport/classReport_top.png'),
      // 参测人数表格
      SurveyPersonnelHeadersList: [
        { label: '应参测人数', key: 'totalTest' },
        { label: '实际参测人数', key: 'ActualTest' },
        { label: '有效问卷人数', key: 'effectiveTest' },
        { label: '有效率', key: 'efficientTest' }
      ],
      SurveyPersonnelBodyList: [],
      getHealthSummaryPieChartData: [],
      healthSummaryTableHeadersList: [
        { label: '高健康状态', key: 'high' },
        { label: '较好健康状态', key: 'preferably' },
        { label: '一般健康状态', key: 'commonly' },
        { label: '亚健康状态', key: 'subhealthy' },
        { label: '预警状态', key: 'early' }
      ],
      healthSummaryTableBodyList: [
        {
          high: '101-120分',
          preferably: '81-100分',
          commonly: '61-80分',
          subhealthy: '41-60分',
          early: '24-40分'
        }
      ],
      barPercentageChartData: {
        name: [],
        man: [],
        male: []
      },
      EarlyPieChartData: {
        chartData: [],
        man: [],
        male: []
      },
      weiduTableHeadersList: [
        { label: '维度', key: 'weidu' },
        { label: '高健康状态', key: 'high' },
        { label: '较好健康状态', key: 'preferably' },
        { label: '一般健康状态', key: 'commonly' },
        { label: '亚健康状态', key: 'subhealthy' },
        { label: '预警状态', key: 'early' }
      ],
      weiduTableDataList: [
        {
          weidu: '认知维度',
          high: '21-25分',
          preferably: '17-20分',
          commonly: '11-16分',
          subhealthy: '8-10分',
          early: '5-7分'
        },
        {
          weidu: '思维与语言维度',
          high: '22-25分',
          preferably: '19-21分',
          commonly: '13-18分',
          subhealthy: '9-12分',
          early: '5-8分'
        },
        {
          weidu: '个性维度',
          high: '27-30分',
          preferably: '22-26分',
          commonly: '14-21分',
          subhealthy: '10-13分',
          early: '6-9分'
        },
        {
          weidu: '情绪维度',
          high: '14-15分',
          preferably: '11-13分',
          commonly: '7-10分',
          subhealthy: '5-6分',
          early: '3-4分'
        },
        {
          weidu: '意志行为维度',
          high: '22-25分',
          preferably: '18-21分',
          commonly: '12-17分',
          subhealthy: '8-11分',
          early: '5-7分'
        }
      ],
      dimentionEarlyPieChartData: {
        name: [],
        value: []
      },
      needChange: {},
      schoolType: ''
    }
  },
  created() {
    if (!this.$route.query.studentClass) {
      this.$fullScreenLoading.show('请传参...')
      this.$message({
        message: '请传递有效参数！',
        type: 'warning'
      })
    } else {
      this.pageInfo = this.$route.query
      document.title = `班级报告 ${this.pageInfo.studentGrade}${
        this.pageInfo.studentClass
      }${new Date().toLocaleDateString()}`
      this.$fullScreenLoading.show('loading...')
      var that = this
      getChildrenTeamReportDetailData(that.queryParams)
        // request({
        //   url: "mirrorego/stuStatistic/detail",
        //   method: "POST",
        //   data: this.pageInfo,
        // })
        .then((res) => {
          this.data = res.data
          this.schoolType = res.data.schoolType
          this.needChange = res.data
          this.SurveyPersonnelBodyList = [
            {
              totalTest: res.data.yinCeRenShu,
              ActualTest: res.data.shiCeRenShu,
              effectiveTest: res.data.youXiaoWenJuan,
              efficientTest: res.data.youXiaoLu * 100 + '%'
            }
          ]
          this.getData()
        })
    }
  },
  mounted() {
    setTimeout(() => {
      // 参测人数图
      this.getTotalPieChart(
        this.needChange.shiCeRenShuFemale,
        this.needChange.shiCeRenShuMan
      )
      this.getHealthSummaryPieChart(this.getHealthSummaryPieChartData)
      this.getbarPercentageChart()
      this.getEarlyPieChart()
      this.getbarEarlyChart()
      this.getbarDimentionChart()
      this.$forceUpdate()
      this.$fullScreenLoading.hide()
      if (this.isExport) {
        this.$notify({
          title: '成功',
          message: '下载PDF中，请稍等一会',
          duration: 2000,
          type: 'success'
        })
        setTimeout(() => {
          htmlToPdf.downloadPDF(
            document.querySelector('#main'),
            `班级报告 ${this.$route.query.studentGrade}${
              this.$route.query.studentClass
            }${new Date().toLocaleDateString()}.pdf`
          )
        }, 1000)

        //  setTimeout(() => {
        //     getReportPdf("#main", `班级报告 ${this.$route.query.studentGrade}${
        //               this.$route.query.studentClass}${new Date().toLocaleDateString()}.pdf`,0.8);
        // }, 1000);
      }
    }, 1500)
  },
  methods: {
    getData() {
      var that = this
      getChildrenTeamReportItemdetail2Data(that.queryParams)
        // request({
        //   url: "mirrorego/stuStatistic/itemdetail2",
        //   method: "POST",
        //   data: this.pageInfo,
        // })
        .then((res) => {
          this.data = { ...this.data, ...res.data }
          res.data.totalScale.map((item) => {
            // 总参测人数状态图
            this.getHealthSummaryPieChartData.push({
              name: item.conclusion,
              value: item.theNumberOfStudent,
              theNumberOfStudent: item.theNumberOfStudent
            })
            // 男女状态对比图
            this.barPercentageChartData.name.push(item.conclusion)
            this.barPercentageChartData.male.push(item.theNumberOfFemale)
            this.barPercentageChartData.man.push(item.theNumberOfMan)
          })
          res.data.alarmItems.map((item) => {
            this.EarlyPieChartData.chartData.push({
              name: item.levelName,
              value: item.theNumberOfStudent
            })
            this.EarlyPieChartData.man.push(item.theNumberOfMan)
            this.EarlyPieChartData.male.push(item.theNumberOfFemale)
          })
          res.data.yuJinItem.map((dimention) => {
            this.dimentionEarlyPieChartData.name.push(dimention.scaleName)
            this.dimentionEarlyPieChartData.value.push(
              dimention.theNumberOfStudent ? dimention.theNumberOfStudent : 0
            )
          })

          this.getHealthSummaryPieChart(this.getHealthSummaryPieChartData)
          this.getbarPercentageChart()
          this.getEarlyPieChart()
          this.getbarEarlyChart()
          this.getbarDimentionChart()
        })
    },
    filterHeaders(value) {
      var list = [{ label: '性别', key: 'gender' }]
      value.map((head) => {
        list.push({
          label: head.conclusion,
          key: tableKey[head.conclusion]
        })
      })
      list.push({
        label: '总计',
        key: 'count'
      })
      return list
    },
    filterTableBody(value) {
      var list = []
      for (let index = 0; index < 2; index++) {
        var obj = {}
        if (index === 0) {
          let count = 0
          value.map((head) => {
            count += head.theNumberOfMan
            obj[tableKey[head.conclusion]] = head.theNumberOfMan
          })
          obj['gender'] = '男'
          obj['count'] = count
        } else {
          let count = 0
          value.map((head) => {
            count += head.theNumberOfFemale
            obj[tableKey[head.conclusion]] = head.theNumberOfFemale
          })
          obj['gender'] = '女'
          obj['count'] = count
        }
        list.push(obj)
      }
      return list
    },
    getTotalPieChart(shiCeRenShuFemale, shiCeRenShuMan) {
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          data: ['男', '女'],
          itemWidth: 30, // 设置图例图形的宽
          itemHeight: 14, // 设置图例图形的高
          itemGap: 30,
          textStyle: {
            fontSize: 20
          }
        },
        color: ['#FFCF58', '#409EFF'],
        series: [
          {
            name: '男／女生参测人员分布情况',
            type: 'pie',
            radius: '70%',
            data: [
              { value: shiCeRenShuFemale, name: '女' },
              { value: shiCeRenShuMan, name: '男' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                fontSize: 28,
                position: 'inner', // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: '{d}%'
              }
            }
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('piePercentageChart')
      )
      myCharts.setOption(option)
    },
    getHealthSummaryPieChart(getHealthSummaryPieChartData) {
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          y: 'center',
          itemWidth: 20, // 设置图例图形的宽
          itemHeight: 20, // 设置图例图形的高
          itemGap: 38,
          textStyle: {
            fontSize: 20
          }
        },
        color: ['#ff4d4c', '#FD8E44', '#FFCF58', '#92E35C', '#0BCC53'],
        series: [
          {
            name: '学生心理健康状态汇总',
            type: 'pie',
            radius: '70%',
            data: getHealthSummaryPieChartData,
            selectedMode: 'single',
            selectedOffset: 30,
            clockwise: true,
            label: {
              normal: {
                fontSize: 24, // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: '{b}{d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('healthSummaryChart')
      )
      myCharts.setOption(option)
    },
    getbarPercentageChart() {
      const { name, man, male } = this.barPercentageChartData
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['男生', '女生'],
          itemWidth: 30, // 设置图例图形的宽
          itemHeight: 14, // 设置图例图形的高
          itemGap: 41,
          textStyle: {
            fontSize: 20
          }
        },
        xAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8AC',
            fontSize: 20
          },
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },
          axisTick: { show: false },
          type: 'category',
          data: name
        },
        yAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8A8',
            fontSize: 20
          },
          splitLine: { show: false },
          type: 'value'
        },
        series: [
          {
            label: {
              // 图形上的文本标签
              show: true,
              position: ['78%', '-50'], // 相对位置
              rotate: -90, // 旋转角度
              color: '#D9D2E9',
              fontSize: 20
            },
            itemStyle: {
              // 图形的形状
              color: '#409EFF',
              barBorderRadius: 5
            },
            name: '男生',
            type: 'bar',
            data: man
          },
          {
            itemStyle: {
              // 图形的形状
              color: '#FFCF58',
              barBorderRadius: 5
            },
            label: {
              // 图形上的文本标签
              show: true,
              position: ['78%', '-50'], // 相对位置
              rotate: -90, // 旋转角度
              color: '#D9D2E9',
              fontSize: 20
            },
            name: '女生',
            type: 'bar',
            data: male
          }
        ]
      }
      var myChart = this.$Echarts.init(
        document.getElementById('barPercentageChart')
      )
      myChart.setOption(option)
    },
    getEarlyPieChart() {
      var option = {
        tooltip: {
          trigger: 'item'
        },
        color: ['#92E35C', '#f20c00', '#f35336', 'yellow'],
        legend: {
          orient: 'vertical',
          x: 'left',
          y: 'center',
          itemWidth: 20, // 设置图例图形的宽
          itemHeight: 20, // 设置图例图形的高
          itemGap: 38,
          textStyle: {
            fontSize: 20
          }
        },
        series: [
          {
            name: '学生心理健康状态汇总',
            type: 'pie',
            radius: '70%',
            data: this.EarlyPieChartData.chartData,
            selectedMode: 'single',
            selectedOffset: 30,
            clockwise: true,
            label: {
              normal: {
                fontSize: 24, // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: '{b}{d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('EarlyPieChart')
      )
      myCharts.setOption(option)
    },
    getbarEarlyChart() {
      const { man, male } = this.EarlyPieChartData
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['男生', '女生'],
          itemWidth: 30, // 设置图例图形的宽
          itemHeight: 14, // 设置图例图形的高
          itemGap: 41,
          textStyle: {
            fontSize: 20
          }
        },
        xAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8AC',
            fontSize: 20
          },
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },
          axisTick: { show: false },
          type: 'category',
          data: ['第一类预警', '第二类预警', '第三类预警']
        },
        yAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8A8',
            fontSize: 20
          },
          splitLine: { show: false },
          type: 'value'
        },
        series: [
          {
            label: {
              // 图形上的文本标签
              show: true,
              position: ['78%', '-50'], // 相对位置
              rotate: -90, // 旋转角度
              color: '#D9D2E9',
              fontSize: 20
            },
            itemStyle: {
              // 图形的形状
              color: '#409EFF',
              barBorderRadius: 5
            },
            name: '男生',
            type: 'bar',
            data: man
          },
          {
            itemStyle: {
              // 图形的形状
              color: '#FFCF58',
              barBorderRadius: 5
            },
            label: {
              // 图形上的文本标签
              show: true,
              position: ['78%', '-50'], // 相对位置
              rotate: -90, // 旋转角度
              color: '#D9D2E9',
              fontSize: 20
            },
            name: '女生',
            type: 'bar',
            data: male
          }
        ]
      }
      var myChart = this.$Echarts.init(
        document.getElementById('EarlyBarChart')
      )
      myChart.setOption(option)
    },
    getbarDimentionChart() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8AC',
            fontSize: 20
          },
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },
          axisTick: { show: false },
          type: 'category',
          data: this.dimentionEarlyPieChartData.name
        },
        yAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8A8',
            fontSize: 20
          },
          splitLine: { show: false },
          type: 'value'
        },
        series: [
          {
            label: {
              // 图形上的文本标签
              show: true,
              position: ['60%', '-50'], // 相对位置
              rotate: -90, // 旋转角度
              color: '#D9D2E9',
              fontSize: 20
            },
            itemStyle: {
              // 图形的形状
              color: '#FFCF58',
              barBorderRadius: 5
            },
            name: '各维度预警状态概述',
            type: 'bar',
            data: this.dimentionEarlyPieChartData.value
          }
        ]
      }
      var myChart = this.$Echarts.init(
        document.getElementById('barDimentionChart')
      )
      myChart.setOption(option)
    }
  }
}

//  setTimeout(() => {
//           try {
//             var html = document.querySelector("#main");
//             let contentWidth = html.clientWidth; // 获得该容器的宽
//             let contentHeight = html.clientHeight; // 获得该容器的高
//             let canvas = document.createElement("canvas");
//             let scale = 1; // 解决清晰度问题，先放大 2倍

//             canvas.width = contentWidth * scale; // 将画布宽&&高放大两倍
//             canvas.height = contentHeight * scale;
//             canvas.getContext("2d").scale(scale, scale);

//             let opts = {
//               scale: scale,
//               canvas: canvas,
//               // width: contentWidth,
//               // height: contentHeight,
//               useCORS: true,
//             };
//             window.Html2canvas ||
//               Html2Canvas(html, opts)
//                 .then((canvas) => {
//                   var contentWidth = canvas.width;
//                   var contentHeight = canvas.height;

//                   //一页pdf显示html页面生成的canvas高度;
//                   var pageHeight = (contentWidth / 592.28) * 841.89;
//                   //未生成pdf的html页面高度
//                   var leftHeight = contentHeight;
//                   //页面偏移
//                   var position = 0;
//                   //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
//                   var imgWidth = 595.28;
//                   var imgHeight = (592.28 / contentWidth) * contentHeight;

//                   var pageData = canvas.toDataURL("image/jpeg", 1.0);

//                   var pdf = new jsPDF("", "pt", "a4");

//                   //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
//                   //当内容未超过pdf一页显示的范围，无需分页
//                   if (leftHeight < pageHeight) {
//                     pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
//                   } else {
//                     while (leftHeight > 0) {
//                       pdf.addImage(
//                         pageData,
//                         "JPEG",
//                         0,
//                         position,
//                         imgWidth,
//                         imgHeight
//                       );
//                       leftHeight -= pageHeight;
//                       position -= 841.89;
//                       //避免添加空白页
//                       if (leftHeight > 0) {
//                         pdf.addPage();
//                       }
//                     }
//                   }
//                   pdf.save(
//                     `班级报告 ${this.pageInfo.studentGrade}${
//                       this.pageInfo.studentClass
//                     }${new Date().toLocaleDateString()}.pdf`
//                   );
//                   //
//                 })
//                 .catch((err) => {
//                 });
//           } catch (err) {
//           }
//         }, 1000);
</script>
<style lang="scss">
.reportContainer {
  width: 100%;
  overflow: hidden;
  padding-bottom: 304px;
  .wsTableList {
    max-width: 80% !important;
  }
  .wsTableList1 {
    max-width: 90% !important;
    min-width: 90% !important;
  }
  .pieChart {
    width: 100%;
    height: 550px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .pie {
      width: 100%;
      height: 100%;
    }
    #barPercentageChart,
    #EarlyBarChart,
    #barDimentionChart {
      margin-top: 52px;
      padding: 0 262px;
    }
  }
  .coverContainer {
    img {
      width: 100%;
      height: auto;
    }
    margin: 0 auto;
    position: relative;
    .coverInfo {
      position: absolute;
      z-index: 1;
      top: 38%;
      left: 50%;
      font-size: 42px;
      color: #fff;
      font-weight: 700;
    }
  }
  .bigTitle {
    width: 620px;
    height: 56px;
    margin: 64px auto 101px;
  }
  .scienceT {
    background: url("../../assets/images/classReport/scienceT.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .noticeT {
    background: url("../../assets/images/classReport/noticeT.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .introT {
    background: url("../../assets/images/caseReport/intro_bigTitle.png")
      no-repeat center;
    background-size: 100% 100%;
  }
  .summaryT {
    background: url("../../assets/images/classReport/summaryT.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .partTest {
    background: url("../../assets/images/classReport/partTest.png") no-repeat
      center;
    background-size: 100% 100%;
    margin-top: 88px;
  }
  .resultT {
    background: url("../../assets/images/classReport/resultT.png") no-repeat
      center;
    background-size: 100% 100%;
    margin-top: 125px;
  }
  .intro {
    width: 100%;
    padding: 0 143px;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 56px;
    .introItem {
      margin-bottom: 58px;
    }
  }
  .formatIntro {
    width: 100%;
    padding: 0 143px;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    margin: 47px 0 23px 0;
    line-height: 56px;
    span {
      font-size: 32px;
      font-weight: bold;
      color: #fab839;
      margin: 0 10px;
    }
  }
  .SurveyingContainner {
    background: none !important;
    margin-top: 68px;
  }
  .detailContainner {
    width: 100%;
    padding: 0 143px;
    background: url("../../assets/images/classReport/referenceBg.png") no-repeat
      right;
    background-size: 500px 580px;
    .detailItem {
      .itemTitle {
        width: 310px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .itemValue {
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 56px;
        margin-bottom: 47px;
      }
    }
  }
  .listContainer {
    width: 100%;
    padding: 0 143px;
    margin-top: 60px;
    .listItem {
      display: flex;
      flex-direction: column;
      margin-bottom: 37px;
      .listTitle {
        display: flex;
        align-items: center;
        .icon {
          width: 34px;
          height: 34px;
          background: url("../../assets/images/caseReport/list_left.png")
            no-repeat center;
          background-size: 100% 100%;

          margin-right: 26px;
        }
        .title {
          font-size: 28px;
          font-weight: 400;
          color: #333333;
        }
      }
      .listValue {
        padding-top: 45px;
        font-size: 28px;
        font-weight: 300;
        color: #333333;
        line-height: 56px;
      }
    }
  }
  .literatureContainer {
    width: 100%;
    min-height: 900px;
    padding: 0 143px;

    margin-top: 60px;
    .literatureItem {
      display: flex;
      margin-bottom: 37px;
      .literatureTitle {
        width: 34px;
        padding-top: 10px;
        margin-right: 26px;
        .icon {
          width: 34px;
          height: 34px;
          background: url("../../assets/images/caseReport/list_left.png")
            no-repeat center;
          background-size: 100% 100%;
        }
      }
      .literatureValue {
        width: 819px;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 56px;
      }
    }
  }
  .resultChart {
    width: 100%;
    height: 450px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    #myCharts {
      width: 100%;
      height: 100%;
    }
  }

  @media screen and (min-width: 300px) and (max-width: 800px) {
    .intro {
      line-height: 100px;
    }
  }
}
</style>
